import "jquery-modal";
import "jquery-form";

function animateBalls(containerSelector, ballsSelector) {
    let container = document.querySelector(containerSelector);
    if (container) {
        let balls = container.querySelectorAll(ballsSelector);

        let iteration = 0;
        let items = [];

        function iterateBalls(func) {
            for (var i in balls) {
                if (balls.hasOwnProperty(i)) {
                    func(balls[i], i);
                }
            }
        }

        iterateBalls((ball, index) => {
            items.push({
                x: 0,
                y: 0,
                el: ball,
                random: Math.random() * 2000,
                realX: 0,
                realY: 0,
            });
        });

        function animate() {
            iteration++;

            iterateBalls((ball, index) => {
                let delta = items[index];

                delta.x = delta.realX;

                let x =
                    Math.sin((iteration + delta.random) / 50) * 10 +
                    delta.realX;
                let y =
                    Math.cos((iteration + delta.random) / 50) * 10 +
                    delta.realY;

                ball.style.transform = `translate(${x}px, ${y}px)`;
            });

            requestAnimationFrame(animate);
        }

        animate();
    }
}

// animateBalls(".sect-free", ".ball-1, .ball-2, .ball-3, .ball-4");
// animateBalls(".banner", ".ball-1, .ball-2, .ball-3, .ball-4");
// animateBalls(".sect-leader", ".ball-1, .ball-2, .ball-3");
// animateBalls(".section__start-banner", ".ball-1, .ball-2, .ball-3");

$(() => {
    $(".pay-btn").on("click", function (e) {
        e.preventDefault();
        let id = $(this).data("id");
        let container = $(this).closest(".pay-course");
        let countryId = container.find('[name="country"]').val();
        let schoolsCount = container.find('[name="schoolsCount"]').val();
        let schoolType = container.find('[name="schoolType"]').val();

        let payload = {
            countryId: countryId || "",
            schoolsCount: schoolsCount || 0,
            schoolType: schoolType || null,
        };

        callPayModal([id], payload, "package");
    });
});

const myTimer = (target, id) => {
    // ищем куки нужные нам, если их нет, то ставим что они живут год
    let string = new RegExp(`price_package${id}=(.+?)(;|$)`);
    let cookie = document.cookie.match(string);
    if (!cookie) {
        let cookie_date = new Date().getTime();
        document.cookie = `price_package${id}=${cookie_date};max-age=31556926`;
    }

    let targetDate = new Date();
    targetDate.setSeconds(targetDate.getSeconds() + Number(target));

    // если куки есть, то таргет дейт у нас идет от куков
    if (cookie) {
        const futureTime = new Date(Number(cookie[1]));
        futureTime.setSeconds(futureTime.getSeconds() + Number(target));
        targetDate = futureTime;
    }

    targetDate = targetDate.getTime();

    let timerBig = setInterval(function () {
        let now = new Date().getTime();
        let distance = `${targetDate}` - now;

        let hours = Math.floor(distance / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        document.getElementById(
            `itemDate${id}`
        ).innerHTML = `<div><span>Успей купить!</span>&nbsp;До конца скидки осталось:</div><span>${hours} часов, ${minutes} минут, ${seconds} секунд</span>`;

        if (distance < 0) {
            clearInterval(timerBig);
            document.getElementById(`itemDate${id}`).innerHTML =
                "К сожалению истекло время скидки на пакет";
            document.getElementById(`price${id}`).innerHTML =
                document.getElementById(`oldPrice${id}`).innerHTML;
            document.getElementById(`oldPrice${id}`).innerHTML = "";
            if (document.getElementById(`select${id}`)) {
                document.getElementById(`select${id}`).dataset.price =
                    document.getElementById(`select${id}`).dataset.old_price;
                document.getElementById(`select${id}`).dataset.old_price = "";
            }
        }
    }, 1000);
};

const daysOfWeek = [
    "воскресенье",
    "понедельник",
    "вторник",
    "среда",
    "четверг",
    "пятница",
    "суббота",
];
const monthsOfYear = [
    "января",
    "февраля",
    "марта",
    "апреля",
    "мая",
    "июня",
    "июля",
    "августа",
    "сентября",
    "октября",
    "ноября",
    "декабря",
];

setInterval(function () {
    const counter = document.querySelector(".counter");

    if (counter) {
        const day = counter.dataset.day;
        const time = counter.dataset.time;

        console.log("dataset", day, time);

        // получаем текущую дату и смотрим сколько до нее
        let currentDate = new Date(),
            targetDay = day || 0, // четверг, начиная с вс=0
            targetDate = new Date();

        var today = new Date();
        let delta = today.getDay() - currentDate.getDay();

        if (delta >= 0) {
            targetDate.setDate(currentDate.getDate() + delta);
        } else {
            targetDate.setDate(currentDate.getDate() + 7 + delta);
        }

        // устанавливаем время, формат 19:00 не поддерживается блейдом
        const targetTime = time ?? "19.00";
        const timesArr = targetTime.split(".");

        targetDate.setUTCHours(timesArr[0], timesArr[1], 0);
        targetDate.setMilliseconds(-3 * 60 * 60 * 1000); // МСК часовой пояс

        // смотрим сколько секунд осталось, если менее 0, то будет счет некст недели
        let ms_left = targetDate - currentDate;

        if (ms_left < 0) {
            targetDate.setDate(currentDate.getDate() + 7 + delta);
            ms_left = targetDate - currentDate;
        }

        let res = new Date(ms_left);
        let hoursRes = Math.round(ms_left / 3600000);
        if (hoursRes < 10) {
            hoursRes = `0${hoursRes}`;
        }

        document.getElementById("hours").innerHTML = `${hoursRes}`;
        document.getElementById("minutes").innerHTML = `${res
            .getMinutes()
            .toString()
            .padStart(2, "0")}`;
        document.getElementById("seconds").innerHTML = `${res
            .getSeconds()
            .toString()
            .padStart(2, "0")}`;

        // устанавливаем время выше счетчика
        const bannerTime = `${timesArr[0]}:${timesArr[1]} (МСК)`;
        document
            .querySelectorAll(".time-banner")
            .forEach((item) => (item.innerHTML = bannerTime));

        // устанавливаем дату выше счетчика
        const dayOfWeek = daysOfWeek[day];
        const monthOfYear = monthsOfYear[targetDate.getMonth()];
        const bannerDate = `${targetDate.getDate()} ${monthOfYear} в ${bannerTime}`;
        // document.getElementById("date-banner").innerHTML = bannerDate;

        document
            .querySelectorAll(".date-banner__text")
            .forEach((item) => (item.innerHTML = bannerDate));
    }
}, 1000);

$(() => {
    $(".pay-course").each(function (i, obj) {
        myTimer(obj.dataset.time, obj.dataset.id);
    });
});

$(() => {
    $(".schools-count").on("change", function () {
        const key = $(this).attr("id");
        let counter = $(this).val() - 3;
        let price;

        if (Number($(this).attr("data-old_price"))) {
            const oldPrice =
                Number($(this).attr("data-old_price")) + counter * 1800;
            $(`#oldPrice${key.split("select")[1]}`).text(`${oldPrice}$`);
            price = Number($(this).attr("data-price")) + counter * 1500;
        } else {
            price = Number($(this).attr("data-price")) + counter * 1800;
        }

        $(`#price${key.split("select")[1]}`).text(`${price}$`);
    });
});

function callPayModal(ids, payload = {}, product_type = "checklist") {
    $.get(
        `/webinar-package/pay-modal-products/?product_type=${product_type}`,
        Object.assign({}, payload, {
            ids: ids,
        }),
        (html) => {
            let div = $("<div></div>");
            div.html(html);
            div.modal("show");
            div.on("modal:close", () => div.remove());

            // calculate price of packages
            function getPrice() {
                let selectedType = $('input[name="pay_type"]:checked').val();
                $.get(
                    `/webinar-package/package-price/`,
                    { ids, pay_type: selectedType },
                    (priceString) => $(".pay-modal__price").html(priceString)
                );
            }

            $('input[name="pay_type"]').on("change", getPrice);

            setTimeout(getPrice, 0);

            let form = div.find("form");

            import("../components/newFormsLoader").then(
                async ({ newFormsLoader }) => {
                    const module = await newFormsLoader();
                    const { newForms, newPhoneInput } = module;

                    const $phone = form.find('input[name="phone"]');

                    if ($phone.length) {
                        newPhoneInput.phoneInput($phone);
                    }

                    // Unbind first to prevent double-binding if this script re-runs
                    form.off("submit").on("submit", function (e) {
                        e.preventDefault();

                        newForms.defaultFormHandle(e, {
                            done: (data) => {
                                console.log("FORM SUBMIT RESPONSE", data);
                                if (data.redirect) {
                                    window.location.href = data.redirect;
                                }
                            },
                        });
                    });
                }
            );
        }
    );
}

window.buyProducts = (ids) => {
    console.log("buy products", ids);
    callPayModal(ids, {});
};

const LG_MAX = 993;
const MD_MAX = 768;
const SM_MAX = 600;

let resize = () => {
    let width = window.innerWidth;

    let movable = $(".banner__col--play");
    let date = $(".banner__subtitle-date");
    let personDateHolder = $(".person__date-holder");
    let bannerTitle = $(".banner__title");
    $(".banner__subtitle-text--short").text(
        "Бесплатный мастер-класс для родителей от экспертов ведущего агентства по зарубежному образованию"
    );

    if (width < LG_MAX) {
        movable.appendTo(".banner__subtitle");
        personDateHolder.append(date);
        bannerTitle.appendTo(".banner__subtitle-text");
    } else {
        movable.insertAfter(".banner__col--first");
        date.insertBefore(".banner__subtitle-text");
        bannerTitle.insertAfter(".banner__subtitle");
    }

    if (width < SM_MAX) {
        bannerTitle.insertAfter(".banner__subtitle");

        $(".banner__subtitle-text--short").text(
            "Бесплатный мастер-класс для родителей"
        );
    }
};

$(resize);

const resizeWbnPkg = () => {
    const width = window.innerWidth;
    const items = $(".price__item");

    $.each(items, (idx, val) => {
        const bannerTop = $(".banner-price__top");
        if (width < MD_MAX) {
            const col = $(val).find(".price__item-col--right");
            const selects = $(val).find(".price__item-selects");
            col.append(selects);

            const bannerInner = $(".banner-price__inner");
            bannerInner.prepend(bannerTop);
        } else {
            const set = $(val).find(".price__item-set");
            const selects = $(val).find(".price__item-selects");
            selects.insertBefore(set);

            const bannerCol = $(".banner-price__col--first");
            bannerCol.prepend(bannerTop);
        }
    });
};

$(resizeWbnPkg);

window.addEventListener("resize", function () {
    resize();
    resizeWbnPkg();
});

$(() => {
    window.onscroll = function () {
        if (
            document.body.scrollTop > 100 ||
            document.documentElement.scrollTop > 100
        ) {
            $(".fixed-register-btn").fadeIn();
            // $(".fixed-register-btn").animate({opacity: 1});
        } else {
            // $(".fixed-register-btn").animate({opacity: 1});
            $(".fixed-register-btn").fadeOut();
        }
    };
});

var getUniqueID = (function () {
    var cntr = 0;

    return function () {
        return cntr++;
    };
})();

// handle section__products2
document.addEventListener("DOMContentLoaded", function () {
    let arrItems = [];

    let popupShowed = false;

    const cartEl = document.querySelector(".cart-selected-items");
    const selectedBtn = cartEl.querySelector(".show-cart-btn");
    const selectedItemsEl = cartEl.querySelector(".selected__items");
    const number = cartEl.querySelector(".number");
    const popup = cartEl.querySelector(".cart-popup");

    function clickOutside(e) {
        e.preventDefault();
        e.stopPropagation();

        document.removeEventListener("click", clickOutside);
        cartEl.classList.remove("active");
    }

    cartEl.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (!popupShowed) {
            console.log("show");

            cartEl.classList.add("active");
            document.addEventListener("click", clickOutside);
        }
    });

    selectedBtn.addEventListener("click", () => {
        if (selectedItemsEl.classList.contains("active")) {
            selectedItemsEl.classList.remove("active");
        } else {
            selectedItemsEl.classList.add("active");
        }
    });

    function showItems() {
        document.getElementById("selectedContent").classList.toggle("show");
    }

    // Отобразить элементы в корзине
    document.querySelectorAll(".show-cart-btn").forEach((item) => {
        showItems();
    });

    cartEl
        .querySelector(".selected__buy")
        .addEventListener("click", function () {
            window.buyProducts(arrItems.map((item) => item.id));
        });

    function recalculateAddedCartText() {
        const selectedInfo = selectedBtn.dataset.selected;
        const goodsInfo = selectedBtn.dataset.goods;

        const count = cartEl.querySelectorAll(".selected__items > div").length;
        number.innerHTML = count;
        selectedBtn.querySelector(
            "span"
        ).innerHTML = `${selectedInfo} ${count} ${goodsInfo}`;
    }

    document
        .querySelectorAll(".add-to-cart, .add-to-cart-modal")
        .forEach((item) => {
            item.addEventListener("click", () => {
                $.modal.close();

                let itemId = item.dataset.id;

                // Получаем контейнер элемента
                let productEl = document.querySelector(
                    '.product[data-id="' + itemId + '"]'
                );
                let buyButtonTextEl =
                    productEl.querySelector(".add-to-cart span");

                // Уже добавлено?
                if (arrItems.find((a) => a.id == itemId)) {
                    return;
                }

                arrItems.push({
                    id: itemId,
                });

                var newId = "selected_" + itemId;

                // Меняем имя кнопки на "добавлено"
                buyButtonTextEl.innerHTML = buyButtonTextEl.dataset.tAdded;
                item.classList.add("disabled");

                document.querySelector(".selected__items").insertAdjacentHTML(
                    "beforeend",
                    `<div id="${newId}" class="selected__item">
                <label>${item.dataset.name}</label>
                <a href="#" class="product-remove-btn">×</a>
            </div>`
                );

                recalculateAddedCartText();

                document
                    .querySelector(`#${newId} .product-remove-btn`)
                    .addEventListener("click", (e) => {
                        e.preventDefault();

                        // Удаление элемента из массива
                        const index = arrItems.indexOf(itemId);
                        arrItems.splice(index, 1);

                        // Удаление элемента из корзины
                        const element = document.getElementById(newId);
                        element.parentNode.removeChild(element);

                        // Вернули имя кнопки
                        buyButtonTextEl.innerHTML = buyButtonTextEl.dataset.t;
                        item.classList.remove("disabled");

                        recalculateAddedCartText();
                    });
            });
        });
});
